export enum EducationalInstitutionActivationBatchType {
  /// <summary>
  /// Students
  /// </summary>
  Student = 0,
  /// <summary>
  /// Guardians Only
  /// </summary>
  Guardian = 1,
  /// <summary>
  /// Teachers Only
  /// </summary>
  Teacher = 2,
}
